module.exports = __webpack_public_path__ + "img/square-light-monochrome-outline.91a4a32.svg";